import type { BetslipItem } from '@/stores/betslip'

export interface BetBuilderDraw {
  event_id: number
  draw_date: string
  cutoff: string
}

export interface BetBuilderMatch {
  game_id: number
  game_name: string
  game_slug: string
  game_logo?: string
  country?: string
  draw: BetBuilderDraw
  market_id: number
  market_group_id: number
  market_name: string
  market_description?: string
  market_slug: string
  outcome_id: number
  game_market_id?: number | null
  label: string
  pick: number
  odds: number
  specifier?: string | null
  numbers: number[][]
  stake: number
  target_win: number
  payout: number
  gap: number
  currency_symbol?: string
  selection_key?: string
  pool_size?: number
  build_index?: number
}

export interface BetBuilderMatchResponse {
  match: BetBuilderMatch
  bet: Record<string, unknown>
}

export type BetBuilderPhase = 'idle' | 'config' | 'scanning' | 'result'

export function matchToBetslipItem(match: BetBuilderMatch): BetslipItem {
  return {
    market_id: match.market_id,
    market_group_id: match.market_group_id,
    game_id: match.game_id,
    game_name: match.game_name,
    draws: [match.draw],
    allAvailableDraws: [match.draw],
    drawCount: 1,
    numbers: match.numbers,
    stake: match.stake,
    betType: match.label,
    odds: match.odds,
    numBets: 1,
    picks: match.pick,
    outcome_id: String(match.outcome_id),
    game_market_id: match.game_market_id ?? undefined,
    label: match.label,
    market_name: match.market_name,
    market_description: match.market_description,
    specifier: match.specifier ?? null,
    select_numbers: true,
    currency_symbol: match.currency_symbol,
  }
}

export function formatOddsLabel(odds: number): string {
  const rounded = Math.round(odds)
  return `${rounded.toLocaleString('en-US')}/1`
}

export function formatMarketLabel(pick: number, odds: number): string {
  const countLabel = pick === 1 ? '1 number' : `${pick} numbers`
  return `${countLabel} · ${formatOddsLabel(odds)}`
}
